"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventType;
(function (EventType) {
    EventType["UserCreated"] = "user-created";
    EventType["UserCompleted"] = "user-completed";
    EventType["HomeCreated"] = "home-created";
    EventType["HomeCompleted"] = "home-completed";
    EventType["ConversationCreated"] = "conversation-created";
    EventType["ExchangeFinalized"] = "exchange-finalized";
    EventType["PageViewed"] = "page-viewed";
    EventType["DashboardViewed"] = "dashboard-viewed";
    EventType["HomeSearchResultsViewed"] = "home-search-results-viewed";
    EventType["HomeDetailViewed"] = "home-detail-viewed";
    EventType["HomesSearched"] = "homes-searched";
    EventType["ExperimentAssigned"] = "experiment-assigned";
})(EventType = exports.EventType || (exports.EventType = {}));
//# sourceMappingURL=EventType.js.map